export const CANVAS_CENTER = 50;

export const BORDER_COLOR = "#2d415e";
export const FILL_COLOR = "#506a91";
